<template>
  <div>
    <!-- <van-nav-bar
      :title="show_config.nav_title"
      :border="false"
      :left-arrow="show_config.show_nav_back"
      fixed
      @click-left="navBackClick"
    /> -->
    <router-view />
    <van-tabbar v-model="active" v-if="show_config.show_tabbar">
      <van-tabbar-item replace to="/home">
        <span>打卡</span>
        <template #icon="props">
          <img :src="props.active ? icon_lock_select : icon_lock_normal" />
        </template>
      </van-tabbar-item>
      <van-tabbar-item replace to="/square">
        <span>广场</span>
        <template #icon="props">
          <img :src="props.active ? icon_square_select : icon_square_normal" />
        </template>
      </van-tabbar-item>
      <van-tabbar-item replace to="/notice"  v-if="_notice_unread_count > 0"
        :badge="_notice_unread_count">
        <span>公告</span>
        <template #icon="props">
          <img :src="props.active ? icon_notice_select : icon_notice_normal" />
        </template>
      </van-tabbar-item>
      <van-tabbar-item v-else replace to="/notice">
        <span>公告</span>
        <template #icon="props">
          <img :src="props.active ? icon_notice_select : icon_notice_normal" />
        </template>
      </van-tabbar-item>
      <van-tabbar-item
        replace
        to="/mine"
        v-if="_message_unread_count > 0"
        :badge="_message_unread_count"
      >
        <span>我的</span>
        <template #icon="props">
          <img :src="props.active ? icon_my_select : icon_my_normal" />
        </template>
      </van-tabbar-item>
      <van-tabbar-item replace to="/mine" v-else>
        <span>我的</span>
        <template #icon="props">
          <img :src="props.active ? icon_my_select : icon_my_normal" />
        </template>
      </van-tabbar-item>
    </van-tabbar>
  </div>
</template>

<script setup>
import { ref, watch, reactive, onMounted } from "vue";
import { useRouter } from "vue-router";
import User from "@/js/user";
import icon_lock_select from "@/assets/icon_lock_select.png";
import icon_lock_normal from "@/assets/icon_lock_normal.png";
import icon_square_select from "@/assets/icon_square_select.png";
import icon_square_normal from "@/assets/icon_square_normal.png";
import icon_notice_select from "@/assets/icon_notice_select.png";
import icon_notice_normal from "@/assets/icon_notice_normal.png";
import icon_my_select from "@/assets/icon_my_select.png";
import icon_my_normal from "@/assets/icon_my_normal.png";
const active = ref(0);
const router = useRouter();
const _message_unread_count = ref(0);
const _notice_unread_count = ref(0)
const show_config = reactive({
  nav_title: "阳光打卡",
  show_nav_back: true,
  show_tabbar: true,
});
watch(
  () => router.currentRoute.value,
  (to) => {
    const { nav_title, show_nav_back, show_tabbar, tab_index } = to.meta;
    show_config.nav_title = nav_title;
    show_config.show_nav_back = show_nav_back;
    show_config.show_tabbar = show_tabbar;
    active.value = tab_index;
  },
  { immediate: true, deep: true }
);

watch(
  () => User.getInstance()._message_unread_count,
  (newValue) => {
    _message_unread_count.value = newValue.value;
  },
  { immediate: true, deep: true }
);
watch(
  () => User.getInstance()._notice_unread_count,
  (newValue) => {
    _notice_unread_count.value = newValue.value;
  },
  { immediate: true, deep: true }
);

const getNavTitle = (listen_title) => {
  if (listen_title) {
    show_config.nav_title = listen_title;
  }
};
onMounted(() => {
  if (User.isLogin()) {
    User.getInstance().updateUnreadMessageCount();
    User.getInstance().updateUnreadNoticeCount();
    User.getInstance().setNavTitleCallBack(getNavTitle);
  }
});
const navBackClick = () => {
  history.back();
  // router.back()
};
</script>

<style>
body {
  margin: 0;
  padding: 0;
  background-color: #f6f6f6;
  /* padding-top: var(--van-nav-bar-height); */
  padding-bottom: constant(safe-area-inset-bottom);
  padding-bottom: env(safe-area-inset-bottom);
}
.van-tabbar--fixed {
  padding-bottom: 10px !important;
  padding-bottom: constant(safe-area-inset-bottom);
  padding-bottom: env(safe-area-inset-bottom);
}

#app,
p {
  margin: 0;
  padding: 0;
}

:root:root {
  --van-blue: #005bac;
  --van-tabbar-item-text-color: #838588;
  --van-button-normal-padding: 0;
  --van-button-default-height: 64px;
  --van-button-default-background: white;
  --van-button-default-border-color: var(--van-blue);
  --van-button-default-color: var(--van-blue);
  --van-button-radius: var(--van-button-default-height);
  --van-swipe-indicator-inactive-background: rgba(255, 255, 255, 0.64);
  --van-swipe-indicator-inactive-opacity: 1;
  --van-cell-line-height: 60px;
  --van-cell-text-color: var(--c-text-color-gray-6);
  --van-cell-font-size: 28px;
  --van-radio-label-margin: 10px;
  --van-nav-bar-background: var(--c-blue-linear-gradient-1);
  --van-nav-bar-title-text-color: #ffffff;
  --van-nav-bar-icon-color: #ffffff;
  --van-popup-round-radius: 0px;
  --van-cell-label-color: red;

  --c-text-color-gray-10: rgba(131, 133, 136, 1);
  --c-text-color-gray-6: rgba(131, 133, 136, 0.6);
  --c-text-color-gray-4: rgba(131, 133, 136, 0.4);
  --c-text-color-black-8: rgba(0, 7, 18, 0.8);
  --c-text-color-black-10: rgba(0, 7, 18, 1);
  --c-text-color-red: rgba(255, 20, 20, 1);
  --c-line-color: rgba(131, 133, 136, 0.2);
  /* --c-blue-linear-gradient: linear-gradient(to right, #008be2, #0053c1);
  --c-blue-linear-gradient-1: linear-gradient(to right, #0053c1, #003d8e); */
  --c-blue-linear-gradient: var(--van-blue);
  --c-blue-linear-gradient-1: var(--van-blue);
}
.button_select {
  /* background: linear-gradient(to right, #008be2, #0053c1) !important; */
  background: var(--van-blue) !important;
  color: white !important;
  border: none !important;
}

.upload_style_button {
  background: var(--van-blue) !important;
  height: 96px !important;
  border: none;
  width: 100%;
  font-weight: bold;
  font-size: 38px !important;
}
</style>
